import { render, staticRenderFns } from "./peixun.vue?vue&type=template&id=5be65a49&scoped=true"
import script from "./peixun.vue?vue&type=script&lang=js"
export * from "./peixun.vue?vue&type=script&lang=js"
import style0 from "./peixun.vue?vue&type=style&index=0&id=5be65a49&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5be65a49",
  null
  
)

export default component.exports